__turbopack_context__.v({
  "giftcard": "kbId7G_giftcard",
  "giftcardimage": "kbId7G_giftcardimage",
  "giftcardtext": "kbId7G_giftcardtext",
});
